import React from 'react'
import {
  Box,
  IconChevronLeft,
  IconChevronRight
} from '@machobear/design-system'

import * as styles from './style.css.ts'

export interface ArrowsProps {
  onPrev(): void
  onNext(): void
}

export const Arrows: React.FC<ArrowsProps> = ({ onPrev, onNext }) => (
  <>
    <Box
      className={styles.arrowLeft}
      component="button"
      background="bodyWhite"
      onClick={e => {
        e.preventDefault()
        e.stopPropagation()
        onPrev()
      }}
      aria-label="Previous image"
    >
      <IconChevronLeft tone="formAccent" />
    </Box>
    <Box
      className={styles.arrowRight}
      component="button"
      background="bodyWhite"
      onClick={e => {
        e.preventDefault()
        e.stopPropagation()
        onNext()
      }}
      aria-label="Next image"
    >
      <IconChevronRight tone="formAccent" />
    </Box>
  </>
)
